export const blockIconsHouseholdDiningNew = (
	<span className='material-symbols-outlined'>dining</span>
);
